module.exports = __webpack_public_path__ + "img/maestro.bb851e951fe2.svg";